import React, { useState } from "react";
import "../../../../css/Common/Components/DesignSystem/FAQ.css";
import { ReactComponent as CloseIcon } from "../../../../assets/icons/close.svg";
import { ReactComponent as PlusIcon } from "../../../../assets/icons/Plus-icon.svg";

/**
 * FAQ component displays a question and its answer in an expandable/collapsible format.
 *
 * @component
 * @param {Object} props - Component props.
 * @param {string} props.question - The FAQ question to display.
 * @param {string|React.ReactNode} props.answer - The answer to the FAQ question.
 * @returns {JSX.Element} The rendered FAQ component.
 *
 * @example
 * <FAQ question="What is your return policy?" answer="You can return items within 30 days." />
 */
const FAQ = ({ question, answer }) => {
  const [isExpanded, setIsExpanded] = useState(false); // Track if the FAQ is expanded

  const toggleFAQ = () => {
    setIsExpanded(!isExpanded); // Toggle the expanded state
  };

  return (
    <>
      <div className="FAQ FAQ-Expanded " onClick={toggleFAQ}>
        <div>
          <div className="Label-Large-Bold">{question}</div>
          {isExpanded && <div className="Content-Large">{answer}</div>}
          {isExpanded ? (
            <CloseIcon className="FAQ-Icon Content" />
          ) : (
            <PlusIcon className="FAQ-Icon Content" />
          )}
        </div>
      </div>
    </>
  );
};

export default FAQ;
